// @core/api/endpoints/team/list_team_role_applications.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTeamRoleApplicationsResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List role applications
 * Returns all pending role change applications for a team. Only team admins can view the full list.
 */
export async function ListTeamRoleApplications(
  team_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTeamRoleApplicationsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/role-applications`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<ListTeamRoleApplicationsResponse>(requestPath, { ...requestOptions, params });
}
